import { useGetChatMonitoringUserQuery } from 'services';

export function useGetChatMonitoringUsers() {
  const { data, error, isLoading, isSuccess, refetch } = useGetChatMonitoringUserQuery();

  return {
    data: data?.data?.rows || [],
    count: data?.data?.count || 0,
    error,
    isLoading,
    isSuccess,
    refetch
  };
}
